import script from "./TokenPoolsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./TokenPoolsList.vue?vue&type=script&lang=ts&setup=true"

import "./TokenPoolsList.vue?vue&type=style&index=0&id=013509cb&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-013509cb"]])

export default __exports__